// extracted by mini-css-extract-plugin
export default {"container":"ActivityTypesFilter_container__N9K6z","option":"ActivityTypesFilter_option__IHPOY"};